import React from 'react';
import BoxHeader from '../../../../../../../components/Layout/Components/Box/Header/BoxHeader';
import BoxHeaderIcon from '../../../../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import Box from '../../../../../../../components/Layout/Components/Box/Box';
import { useDispatch, useSelector } from 'react-redux';
import DynamicMaterialIcon from '../../../../../../../components/DynamicMaterialIcon/DynamicMaterialIcon';
import styled from 'styled-components';
import PresetButton from './PresetButton';
import { lighten, darken } from 'polished';
import { addItemToTransactionAction } from '../../actions';

const Presets = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const CategoryView = ({ category, transactionId, disabled=false }) => {
  const state = useSelector((state) => state?.presets?.data);
  const currentCategory = state?.categories?.find((cat) => category === cat.ID);
  const dispatch = useDispatch();

  return (
    <Box style={{ flex: 1, marginTop: '40px', transition: 'opacity 1s ease-out' }}>
      <BoxHeader>
        <BoxHeaderIcon color={currentCategory.color}>
          <div style={{ width: '30px', height: '30px', textAlign: 'center' }}>
            <DynamicMaterialIcon name={currentCategory.icon} />
          </div>
        </BoxHeaderIcon>
        <div>
          <h3 style={{ margin: '0px', padding: '10px', color: '#999999' }}>{currentCategory.name}</h3>
        </div>
      </BoxHeader>
      <Presets>
        {state?.presets
          ?.filter((preset) => preset.FKID_category === category)
          ?.map((item, index) => {
            return (
              <PresetButton
                disabled={disabled}
                key={index}
                label={item.name}
                fontColor={darken('0.3', currentCategory.color)}
                color={lighten('0.3', currentCategory.color)}
                icon={'AddOutlined'}
                onClick={() => {
                  !disabled && dispatch(addItemToTransactionAction(transactionId, item.itemID, 1));
                }}
              />
            );
          })}
      </Presets>
    </Box>
  );
};

export default CategoryView;
